import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ShowBlogs from "./Components/ShowBlogs";
import BlogStats from "./Components/BlogStats";
import UserStats from "./Components/UserStats";


function AdminBlogs() {

    const navigate = useNavigate();
    const [adminName, setAdminName] = useState("Jatin Gupta");
    const [showStats, setShowStats] = useState(false);
    const [isSubmittingIndexNow, setIsSubmittingIndexNow] = useState(false);

    const handleBulkSubmitIndexNow = async () => {
        const apiDomain = process.env.REACT_APP_API_URL || 'https://api.omsoftwares.in/api/';
        try {
            setIsSubmittingIndexNow(true);
            const response = await fetch(`${apiDomain}seo/indexnow-bulk`);
            const data = await response.json();
            if (data.success) {
                alert(`Success! ${data.message}`);
            } else {
                alert("Failed to submit to IndexNow: " + data.error);
            }
        } catch (error) {
            console.error(error);
            alert("Error submitting to IndexNow. See console.");
        } finally {
            setIsSubmittingIndexNow(false);
        }
    };
    
   useEffect(() => {
      // If authToken exists in session storage, redirect to the admin dashboard
      if (!sessionStorage.getItem("authToken")) {
        navigate("/admin/login");
      }
      if (sessionStorage.getItem("authToken")) {

        const userType = sessionStorage.getItem("userType");
        if (userType === "blogger") {
          navigate("/blogger");
        } else if (userType === "admin") {
       return;
        }
      }
    }, [navigate]);


    return (
        <>
            <div className="admin-dashboard-container container">
                <div className="dashboard-header">
                    <h1>Welcome, {adminName}</h1>
                    <div className="flex justify-content-between" style={{

                        padding: "8px",
                        display: "flex",
                        gap: "10px",
                    }}>
                        <button
                            className="logout-button"
                            onClick={() => {
                                navigate("/admin");
                            }}
                        >
                            Admin Home
                        </button>
                        <button
                            className="logout-button"
                            onClick={() => navigate("/admin/blogs/create")}
                        >
                            Create Blog
                        </button>
                        <button
                            className="logout-button"
                            onClick={() => setShowStats(!showStats)}
                        >
                            {showStats ? "Hide Stats" : "Show Stats"}
                        </button>
                        <button
                            className="logout-button"
                            onClick={() => {
                                navigate("/admin/users");
                            }}
                        >
                            Users
                        </button>
                        <button
                            className="logout-button"
                            style={{ backgroundColor: "#28a745", color: "white" }}
                            onClick={handleBulkSubmitIndexNow}
                            disabled={isSubmittingIndexNow}
                        >
                            {isSubmittingIndexNow ? "Submitting..." : "Submit All to IndexNow"}
                        </button>
                        <button
                            onClick={() => {
                                sessionStorage.removeItem("authToken");
                                sessionStorage.removeItem("userType");
                                navigate("/admin/login");
                            }}
                            className="logout-button"
                        >
                            Logout
                        </button>
                    </div>
                </div>

                {showStats && (
                    <>
                        <BlogStats />
                        <UserStats />
                    </>
                )}

                <ShowBlogs />
            </div>


        

        </>
    );
}

export default AdminBlogs;